/* eslint-disable no-unused-vars */
import { useDispatch } from 'react-redux';
import * as S from './SelectedItem.styled';
import { DeleteIcon, closeIcon } from 'assets/icons';
import { targetingBrandsModelsActions } from 'store/actions';
import { ParagraphWithTooltip, IconButton } from 'components';

const ParentItem = ({ title, childrenName, deleteIncAction }) => {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(targetingBrandsModelsActions.changeFlag(false));
    deleteIncAction();
  };
  return (
    <S.Item>
      <S.Label>{title}:&nbsp;</S.Label> <ParagraphWithTooltip text={childrenName} />
      <S.DeleteBtn>
        <IconButton.SmallSize
          isDefaultMuted
          icon={DeleteIcon}
          type={IconButton.btnTypes.tertiary}
          onClick={handleClick}
        />
      </S.DeleteBtn>
    </S.Item>
  );
};

const ChildrenItem = ({ title, childrenName, exclude, deleteExcAction, deleteIncAction }) => {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(targetingBrandsModelsActions.changeFlag(false));
    if (exclude) {
      deleteExcAction();
    } else {
      deleteIncAction();
    }
  };
  return (
    <S.Item>
      <S.Label exclude={exclude}>{title}:&nbsp;</S.Label>
      <ParagraphWithTooltip text={childrenName} />
      <S.DeleteBtn>
        <IconButton.SmallSize
          isDefaultMuted
          icon={DeleteIcon}
          type={IconButton.btnTypes.tertiary}
          onClick={handleClick}
        />
      </S.DeleteBtn>
    </S.Item>
  );
};

const SelectedItem = { ParentItem, ChildrenItem };

export default SelectedItem;
